import { makeAutoObservable } from "mobx"
class Token{
    token=localStorage.getItem("token");
    constructor(){
        makeAutoObservable(this);
    }
    removeToken(){
        this.token=null;
        localStorage.removeItem("token");
        window.location.href="/login";
    }
    
}
const TokenStore=new Token();
export default TokenStore;